import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LayoutRoutingModule } from './layout-routing.module';
import { BaseComponent } from './base/base.component';
import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { SearchComponent } from './search/search/search.component';


@NgModule({
  declarations: [
    BaseComponent,
    NavbarComponent,
    SidebarComponent,
    SearchComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    LayoutRoutingModule,
    TranslateModule
  ]
})
export class LayoutModule { }
